import { createApp } from "vue";
import VueKonva from "vue-konva";
import App from "./App.vue";
import router from "./app/router";
import store from "./app/store";
import i18n from "./locales";
import "./style.css";
import "./app/router/guards";

const app = createApp(App);

app.use(store);
app.use(i18n);
app.use(router);
app.use(VueKonva);

app.mount("#app");
